import { api } from './client';
import { Turbine, NewTurbine, UpdateTurbine, TurbinesResponse, FailureFilters } from '@/types';
import { PaginationParams } from '@/types/api';
import { transformFiltersToTurbineFilterList } from '@/utils';


export const turbinesApi = {
  getTurbines: async (
    pagination: PaginationParams & { site_id?: string }
  ): Promise<TurbinesResponse> => {
    const params = new URLSearchParams({
      page: pagination.page.toString(),
      size: pagination.size.toString(),
    });

    if (pagination.orderBy) {
      params.append('orderBy', pagination.orderBy);
    }

    if (pagination.site_id) {
      params.append('site_id', pagination.site_id);
      return api.get<TurbinesResponse>(`/turbines/filter/site?${params.toString()}`);
    } else {
      return api.get<TurbinesResponse>(`/turbines?${params.toString()}`);
    }
  },

  getTurbineById: async (turbineId: string): Promise<Turbine> => {
    return api.get<Turbine>(`/turbines/${turbineId}`);
  },

  getTurbineByFilterList: async (
    filters: FailureFilters,
  ): Promise<TurbinesResponse> => {
    const turbineFilter = await transformFiltersToTurbineFilterList(filters);

    return api.post<TurbinesResponse>(`/turbines/filter/turbine_filter_list?size=${filters.size}&page=${filters.page}`, turbineFilter);
  },

  createTurbine: async (turbineData: NewTurbine): Promise<Turbine> => {
    return api.post<Turbine>('/turbines/new', turbineData);
  },

  updateTurbine: async (turbineData: UpdateTurbine): Promise<Turbine> => {
    return api.put<Turbine>('/turbines/update', turbineData);
  },

  deleteTurbine: async (turbineId: string): Promise<void> => {
    return api.delete(`/turbines/${turbineId}`);
  },

  searchTurbines: async (
    pagination: PaginationParams,
    filters: Record<string, string>
  ): Promise<TurbinesResponse> => {
    const params = new URLSearchParams({
      page: pagination.page.toString(),
      size: pagination.size.toString(),
    });

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    return api.get<TurbinesResponse>(`/turbines/search?${params.toString()}`);
  },
};
